export default __webpack_public_path__ + "static/Construction-Photo2-a6c79ebec576c49eef4b996bb597e373.png";